export default "__VITE_ASSET__BiYucQbs__"